import React, { Component } from 'react';

import { Provider, observer } from 'mobx-react';
import InternalStore from './stores/internal'
import Translate from './stores/i18n'
import ClientData from './stores/clientDetails'

import '../src/globalStyle.scss';


//GLOBAL
import CustomSnackbar from './components/global/snackbar';

var LoginRoute = null;
var LoggedRoute = null;

//const cookies = new Cookies();

@observer
export default class Touchable extends Component {
    constructor(props) {
        super(props)

        // loads the data from localStorage into mobx after page re-load
        const savedUser = JSON.parse(localStorage.getItem('user'))
        const accessToken = JSON.parse(localStorage.getItem('access_token'))
        if (savedUser) {
            savedUser.access_token = accessToken ? accessToken.access_token : ''
            InternalStore.loginUser(savedUser, true)
        }
    }

    render() {

        if (!InternalStore.user.logged && LoginRoute === null) {
            LoginRoute = require('./routes/login').default
        }
        if (InternalStore.user.logged && LoggedRoute === null) {
            LoggedRoute = require('./routes/logged').default
        }
        return (
            InternalStore.init ?
                <Provider
                    internal={InternalStore}
                    translate={Translate}
                    client={ClientData}
                >
                    <div className={'flex'}>
                        {!InternalStore.user.logged && LoginRoute !== null ?
                            <LoginRoute /> : null
                        }
                        {InternalStore.user.logged && LoggedRoute !== null ?
                            <LoggedRoute /> : null
                        }

                        {/* <Loader internal={InternalStore} /> */}
                        <CustomSnackbar message={InternalStore.dataSnackbar.msg} open={InternalStore.dataSnackbar.open} error={InternalStore.dataSnackbar.error} />
                    </div>
                    
                </Provider>

                : <div>loader</div>

        );
    }
}







// WEBPACK FOOTER //
// ./src/App.jsx